import { apiUrl } from '../../constants/urls'

const getIncomingUrl = (feedId, incomingId = '') =>
  `${apiUrl}/feeds/${feedId}/incoming/${incomingId}`

export default getIncomingUrl
